import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

import Widget from '../../../../../components/Widget/Widget';
import { useStyles } from '../../styles';

function ConnectPageSkeleton () {
    const classes = useStyles();

    return (
        <div>
            <div className={classes.widgetContainer}>
                <Widget
                    className={classes.widgetContainer}
                    buttonFlag={false}
                    title={<Skeleton width={120} />}
                    inheritHeight
                    disableWidgetMenu
                />
            </div>
            <div className={classes.widgetContainer}>
                <Widget buttonFlag={false} disableWidgetMenu inheritHeight>
                    <Skeleton variant="rectangular" height={660} />
                </Widget>
            </div>
        </div>
    );
}

export default ConnectPageSkeleton;
